export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '755433aa0emsh176ebaa9ece64a3p1ab067jsna8e5a42bb823',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";

export const WEATHER_API_KEY = "25dd6ec78f0360d2b0afa5eab5919094";
